/** Shared UI text, Chinese. Keys must match ../en/common.ts. */
const common = {
  language: {
    zh: '中文',
    en: 'English',
  },
};

export default common;
